import { useDialog } from '@gyym/ui'
import { usePathname, useSearchParams } from 'next/navigation'
import React from 'react'

import { useAuthUser } from './useAuthUser'
import { useResendVerificationEmail } from './useResendVerificationEmail'

export const useCheckResendVerificationEmail = () => {
  const { isLoggedIn, isEmailVerified } = useAuthUser()
  const { openDialog } = useDialog()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const intended = `${pathname}${searchParams?.toString() ?? ''}`
  const resendVerificationEmail = useResendVerificationEmail(intended)

  const shouldResend = isLoggedIn && !isEmailVerified

  const open = React.useCallback(() => {
    if (!shouldResend) return

    openDialog({
      title: 'メールアドレスが未認証です',
      body: (
        <>
          メール認証が完了していません。
          <br />
          登録メールの送信から時間が経過している場合は再度登録メールを再送して認証を完了させてください。
        </>
      ),
      positiveAction: {
        label: 'メールを再送',
        onClick: resendVerificationEmail,
      },
    })
  }, [shouldResend, openDialog, resendVerificationEmail])

  return {
    shouldResendVerificationEmail: shouldResend,
    openResendVerificationDialog: open,
  }
}
